<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'title.modify-columns-visible' | translate}}</h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="alert alert-warning" role="alert">
  {{ 'message.hint.changes-made-here-are-only-for-the-logged-in-user' | translate }}
</div>

<div class="modal-body">
  <div class="card">
    <div class="card-body">
      <p-pickList [source]="unselectedColumns" [target]="selectedColumns" sourceHeader="{{'common.unselected' | translate}}" targetHeader="{{'common.selected' | translate}}" [responsive]="true"
        [dragdrop]="true" [sourceStyle]="{'height':'20rem'}" [targetStyle]="{'height':'20rem'}" filterBy="header" [sourceFilterPlaceholder]="'hint.search-in-result' | translate"
        [targetFilterPlaceholder]="'hint.search-in-result' | translate">
        <ng-template let-item pTemplate="item">
          {{item.header}}
        </ng-template>
      </p-pickList>

    </div>
  </div>
</div>

<div class="modal-footer">

  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>
  <button class="btn btn-outline-primary m-1 pull-right" (click)="reset()">
    {{'button.reset' | translate}}
  </button>

  <button class="btn btn-primary m-1 pull-right" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>